import React from 'react';
import { Outlet } from 'react-router-dom';

import { useRolesMatch, Roles, and, not } from '@/js/libs/use-auth';

import Status from 'src/scenes/Status';
import { useRouteParams } from '../hooks';
import { BroadcastUrlType } from '../types';

const BROADCAST_ROLES = {
  [BroadcastUrlType.TV]: Roles.MANAGE_TV_PRODUCTS,
  [BroadcastUrlType.RADIO]: Roles.MANAGE_RADIO_PRODUCTS,
};

export const BroadcastRoleChecker = React.memo(function BroadcastRoleChecker() {
  const { broadcastType } = useRouteParams();
  const role = BROADCAST_ROLES[broadcastType];
  const hasAccess = useRolesMatch({ roles: and(role, not(Roles.POSTNETZ_BRANCH_USER)) });

  if (!hasAccess) {
    return <Status.NotFound />;
  }

  return <Outlet />;
});
